import {Observable, Subject} from 'rxjs';
import {Injectable} from '@angular/core';
import {ApiService} from './api.service';
import {Cacheable, CacheBuster} from 'ts-cacheable';
import {DataResponse, ListResponse, SuccessResponse} from '../models/response.model';
import {TopicQuestionary, TopicQuestionaryDetails} from '../models/topic-questionary.model';

const cacheNotifier: Subject<void> = new Subject();

@Injectable({
  providedIn: 'root'
})
export class TopicQuestionaryService {

  constructor(private api: ApiService) {
  }

  getById(id: number): Observable<DataResponse<TopicQuestionary>> {
    return this.api.get(`/topic/questionary/${id}`);
  }

  getDetail(id: number): Observable<TopicQuestionaryDetails> {
    return this.api.get(`/topic/index/${id}/questionary-detail`);
  }

  getByIndex(id: number): Observable<DataResponse<TopicQuestionary>> {
    return this.api.get(`/topic/index/${id}/questionary`);
  }

  getQuestionaryResult(data: object) {
    return this.api.get(`/topic/questionary/result`, data);
  }

  @CacheBuster({
    cacheBusterNotifier: cacheNotifier
  })
  create(data: object): Observable<DataResponse<TopicQuestionary>> {
    return this.api.post(`/topic/questionary`, data);
  }

  @CacheBuster({
    cacheBusterNotifier: cacheNotifier
  })
  createDetail(data: object): Observable<DataResponse<TopicQuestionaryDetails>> {
    return this.api.post(`/topic/index/questionary-detail`, data);
  }

  @CacheBuster({
    cacheBusterNotifier: cacheNotifier
  })
  update(id: number, data: object): Observable<DataResponse<TopicQuestionary>> {
    return this.api.put(`/topic/questionary/${id}`, data);
  }

  @CacheBuster({
    cacheBusterNotifier: cacheNotifier
  })
  updateDetail(id: number, data: object): Observable<DataResponse<TopicQuestionaryDetails>> {
    return this.api.put(`/topic/index/${id}/questionary-detail`, data);
  }

  @CacheBuster({
    cacheBusterNotifier: cacheNotifier
  })
  delete(id: number): Observable<SuccessResponse> {
    return this.api.delete(`/topic/questionary/${id}`);
  }

  static clearCache() {
    cacheNotifier.next();
  }
}
